import cn from 'clsx';
import { FC, HTMLAttributes } from 'react';

import { Justify } from '../../types/justify.type';
import DialogTitle from '../Dialog/DialogTitle';

import s from './Modal.module.scss';

interface Props {
  title?: string;
  justify?: Justify;
}

type NativeAttrs = Omit<HTMLAttributes<HTMLDivElement>, keyof Props>;

export type ModalHeaderProps = Props & NativeAttrs;

const ModalHeader: FC<React.PropsWithChildren<React.PropsWithChildren<ModalHeaderProps>>> = ({ children, justify = 'center', title, ...props }) => {
  const renderComponent = () => {
    if (title) {
      return <DialogTitle title={title} />;
    }
    return children;
  };
  return (
    <div className={cn(s.header, `justify-${justify}`)} {...props}>
      {renderComponent()}
    </div>
  );
};

export default ModalHeader;
